import { addUtmTrackerParam, addUtmTrackers } from '@ifixit/analytics';
import { useAppContext } from '@ifixit/app/hooks';
import { useAuthenticatedUser } from '@ifixit/auth-sdk/client';
import { useStoreLocale } from '@ifixit/i18n/hooks';
import { useCart } from './use-cart';

type Checkout = {
   checkoutUrl: string | undefined;
};

export function useCheckout(): Checkout {
   const { ifixitOrigin } = useAppContext();
   const storeLocale = useStoreLocale();
   const user = useAuthenticatedUser();
   const cartQuery = useCart();
   if (!cartQuery.data?.checkoutUrl) {
      return { checkoutUrl: undefined };
   }
   const checkoutUrl = new URL(cartQuery.data.checkoutUrl);
   addUtmTrackerParam(checkoutUrl);
   addUtmTrackers(checkoutUrl);
   const ssoRoute = `${ifixitOrigin}/User/sso/shopify/${storeLocale}?checkout=1`;
   const ssoUrl = new URL(ssoRoute);
   ssoUrl.searchParams.set('return_to', checkoutUrl.toString());
   const isLoggedIn = Boolean(user.data);
   return {
      checkoutUrl: isLoggedIn ? ssoUrl.toString() : checkoutUrl.toString(),
   };
}
